import initMaterialize from '../../base/form';
import refreshInputs from './inputs/refresh';

export default function refresh() {
  initMaterialize();
  refreshInputs();
}
